<app-moveable-panel>
  <div class="flex flex-col">
    <app-movable-panel-title>
      <div class="grow flex items-center justify-between">
        <span>{{ 'multi-site-dashboard.site-fleets-overview.title' | translate }}</span>
        <div class="flex items-center">
          <ng-content></ng-content>
        </div>
      </div>
    </app-movable-panel-title>

    <div class="flex flex-col gap-2 px-2 max-h-[572px] overflow-auto">
      @if (isLoading()) {
        @for (_ of skeletonRows; track $index) {
          <app-at-a-glance-site-card-loading-skeleton />
        }
      } @else {
        @for (card of vm()?.cards ?? []; track card.siteId) {
          <app-at-a-glance-site-card [vm]="card" />
        }
      }
    </div>

    <div class="flex items-center justify-end p-4">
      <a [routerLink]="[RouteSegment.Root, RouteSegment.Sites]">
        <app-panel-link [label]="'multi-site-dashboard.view-sites' | translate"></app-panel-link>
      </a>
    </div>
  </div>
</app-moveable-panel>
